export default __webpack_public_path__ + "static/media/daniel-olahh.c1d6df77.jpg";